import React, { useState, useEffect, useCallback } from "react";
import Header from "../Header";
import * as commonData from "../Common";
import Cookies from "js-cookie";
import Loading from "../components/UI/Loading";
import { withRouter } from "react-router-dom";

const Home = (props) => {
  const apiurl = commonData.commonData().apiUrl;
  const [state, setState] = useState({
    loading: 0,
  });
  useEffect(() => {
    window.document.title = props.title || "";
    const urlParams = new URLSearchParams(window.location.search);
    const accountLogin = urlParams.get("accountLogin")
      ? urlParams.get("accountLogin")
      : 0;
    const userId = urlParams.get("login") ? urlParams.get("login") : 0;

    const urlQueryParams = Object.fromEntries(urlParams.entries());
    let redirectUrl = urlQueryParams?.redirect;

    if (accountLogin == 1) {
      let cookie = Cookies.get("token");
      getValidateToken(cookie);
    } else if (
      localStorage.getItem("userLogin") === "yes" &&
      localStorage.getItem("app_token") &&
      localStorage.getItem("user_details") &&
      localStorage.getItem("user_uuid")
    ) {
      if (redirectUrl) {
        return (window.location.href = redirectUrl);
      }
      window.location.href = "/tattle/support-ticket/list";
    } else if (userId) {
      fetch(apiurl + "SsoLogin?user_id=" + userId)
        .then((response) => response.json())
        .then((result) => {
          var encdata = result.encdata;
          result = commonData.decrypt(encdata, 0);
          if (result.code == 200) {
            // function calling to setup localstoage
            localStorageSetup(result, redirectUrl);
          } else {
            window.location.href = process.env.REACT_APP_LOGIN_URL;
          }
        });
    } else {
      props.history.replace("/login");
    }
  }, []);
  const localStorageSetup = (result, redirectUrl) => {
    var check_is_admin = result.data.user_type == "ROLE_ADMIN" ? 1 : 0;
    const user_details = JSON.stringify(result?.data?.user);
    const userDetailsParse = JSON.parse(user_details);
    commonData.setToStorage("is_admin", check_is_admin);
    commonData.setToStorage("user_uuid", userDetailsParse[0].user_uuid);
    commonData.setToStorage("app_token", userDetailsParse[0].app_token);
    commonData.setToStorage("userLogin", "yes");
    Cookies.set("token", result.token);
    commonData.setToStorage("user_details", user_details);
    // Cookies.set("token", result.token, {
    //   path: "/",
    //   domain: process.env.REACT_APP_COOKIE_DOMAIN,
    // });
    sessionStorage.setItem("userLogin", "yes");
    // this.setState({ redirect: true });

    if (redirectUrl) {
      return (window.location.href = redirectUrl);
    }
    window.parent.location = "/tattle/support-ticket/list";
  };

  // function for set local storage

  const getValidateToken = useCallback(async (cookie) => {
    const resp = await fetch(`${apiurl}validateUserToken`, {
      method: "post",
      body: JSON.stringify({ token: cookie }),
    });

    const resdata = await resp.json();
    const datares = commonData.decrypt(resdata.encdata);
    if (
      datares &&
      datares?.code !== 500 &&
      datares?.code !== 400 &&
      datares?.code !== 403
    ) {
      if (datares?.data?.user.length === 0) {
        props.history.push("/login", {
          message:
            "Account does not exist. Please check your details and try again",
          board: true,
          title: "Error",
          bg: "danger",
        });

        return;
      }
      const user_details = JSON.stringify(datares?.data?.user);

      const userDetailsParse = JSON.parse(user_details);
      let check_is_admin = datares?.data?.user_type == "ROLE_ADMIN" ? 1 : 0;
      commonData.setToStorage("is_admin", check_is_admin);
      commonData.setToStorage("user_uuid", userDetailsParse[0]?.user_uuid);
      commonData.setToStorage("app_token", userDetailsParse[0]?.app_token);
      commonData.setToStorage("userLogin", "yes");
      commonData.setToStorage("token", datares.token || "");
      commonData.setToStorage("user_details", user_details);
      //Cookies.set("token", datares.token || "");
      sessionStorage.setItem("userLogin", "yes");
      window.location = "/board/list";
    } else {
      props.history.replace("/logout");
    }
  }, []);
  const getHomeDetails = () => {
    return (
      <div className="intranet_body dashboard">
        <Loading />
      </div>
    );
  };
  return (
    <div className="mainContent-panel-wrap">
      <Header brecum_name={{ name: "", link: "" }} brecum_page={props.title} />
      <div className="right_col   d-flex justify-content-center align-items-center">
        {getHomeDetails()}
      </div>
    </div>
  );
};
export default withRouter(Home);
